<template>
  <div style="width: 100%">
    <v-data-table
      :headers="headers"
      :items="items"
      :hide-default-header="empty"
      :height="items.length > 7 ? (32 * 7 + 32 + 16) : undefined"
      disable-pagination
      item-key="uid"
      hide-default-footer
      dense
      style="white-space: nowrap"
    >
    <template v-slot:top v-if="toolbar">
      <v-toolbar flat dense>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-divider class="mx-2" inset vertical/>
        <v-btn @click="row_create" small class="ma-2" color="primary">Add</v-btn>
        <v-spacer/>
      </v-toolbar>
    </template>

    <template v-slot:item.index="{ index }">
      <span>{{ index + 1 }}</span>
    </template>

    <template v-slot:item.actions="{ item, index }">
      <v-icon @click="row_moveup(item, index)" class="mr-2" small>mdi-arrow-up-thick</v-icon>
      <v-icon @click="row_movedown(item, index)" class="mr-2" small>mdi-arrow-down-thick</v-icon>
      <v-icon @click="row_remove(item, index)" class="mr-2" small>mdi-delete</v-icon>
    </template>
    </v-data-table>

    <r-smart-offer-dropdown-dialog ref="dialog"/>
  </div>
</template>

<script>
import VueTypes from "vue-types";
import { ViewRules } from "@/common/ViewRules";
import { SmartOffer } from "@/modules/redactor/models/smart-offer/core/SmartOffer";
import { RedactorUtils } from "@/modules/redactor/core/RedactorUtils";
import RSmartOfferDropdownDialog from "@/modules/redactor/views/smart-offer/r-smart-offer-dropdown-dialog.vue";

export default {
  name: "r-smart-offer-table",
  components: { RSmartOfferDropdownDialog },
  props: {
    title: VueTypes.string,
    items: VueTypes.arrayOf(VueTypes.instanceOf(SmartOffer)),
    toolbar: VueTypes.bool.def(true),
  },
  data: () => ({
    headers: [
      { text: "Name", value: "name" },
      { text: "Kind", value: "kind.name" },
      { text: "", value: "actions", width: "100%", sortable: false, align: "end" },
    ],
  }),
  computed: {
    empty() {
      return (this.items || []).length === 0;
    },
  },
  methods: {
    idsToOffers(payload) {
      const ids = Array.isArray(payload) ? payload : (payload ? [payload] : []);
      return ids
        .map(id => (typeof id === "string" ? RedactorUtils.getSmartOffer(id) : id))
        .filter(Boolean);
    },

    row_create() {
      this.$refs.dialog
        .show(ViewRules.CREATE)
        .then((data) => {
          const offers = this.idsToOffers(data);
          if (!offers.length) return;

          const existing = new Set(this.items.map(o => o.uid || o.id));
          const toAdd = offers.filter(o => !existing.has(o.uid || o.id));

          if (!toAdd.length) {
            this.$alert?.("Duplicate value!");
            return;
          }
          this.items.push(...toAdd);
        })
        .catch(() => {});
    },

    row_remove(item, index) {
      this.$confirm("Are you sure you want to delete this item?").then(() => {
        if (index >= 0) this.items.splice(index, 1);
        else {
          const i = this.items.indexOf(item);
          if (i >= 0) this.items.splice(i, 1);
        }
      });
    },

    row_moveup(item, index) {
      if (index > 0) {
        this.items.splice(index - 1, 2, this.items[index], this.items[index - 1]);
      }
    },

    row_movedown(item, index) {
      if (index < this.items.length - 1) {
        this.items.splice(index, 2, this.items[index + 1], this.items[index]);
      }
    },
  },
};
</script>
